import Container from "components/general/Container";
import PageHeader from "components/general/Headers/PageHeader";
import PageLoader from "components/general/PageLoader";
import ScrollContainer from "components/general/ScrollContainer";
import { Box, Typography, HStack, VStack, FormattedCurrency } from "components/ui";
import { useLocalSearchParams } from "expo-router";
import React from "react";
import { useGetInvoiceByDocumentNumberQuery } from "store/abcoApi";
import { Col, Row, Container as GridContainer } from "react-native-flex-grid";
import Section from "components/general/Section";

export default function Page() {
	const { id } = useLocalSearchParams<{ id: string }>();

	const { data, isLoading, isFetching } = useGetInvoiceByDocumentNumberQuery({
		documentNumber: id,
	});

	if (isLoading || isFetching) {
		return (
			<Box minHeight={150}>
				<PageLoader />
			</Box>
		);
	}

	return (
		<ScrollContainer>
			<Container>
				<Box>
					<PageHeader title={`Invoice: ${data?.documentNumber}`} />
					<Section>
						<Box width="100%" marginTop={24}>
							<Box paddingVertical={20} paddingHorizontal={24} marginBottom={24}>
								<HStack justifyContent="space-between" alignItems="center">
									<Box flex={2}>
										<Typography.H5 color="$neutral700">Stock Code</Typography.H5>
									</Box>
									<Box flex={4}>
										<Typography.H5 color="$neutral700">Description</Typography.H5>
									</Box>
									<Box flex={1} alignItems="center">
										<Typography.H5 color="$neutral700">Qty</Typography.H5>
									</Box>
									<Box flex={1} alignItems="flex-end">
										<Typography.H5 color="$neutral700">Total</Typography.H5>
									</Box>
								</HStack>
							</Box>

							<VStack space="md">
								{data?.lineCollection?.map((item, index) => (
									<Box
										key={index}
										bg="$basicwhite"
										borderRadius={12}
										paddingVertical={20}
										paddingHorizontal={24}
										borderWidth={1}
										borderColor="$neutral100"
										shadowColor="$neutral200"
										shadowOffset={{ width: 0, height: 2 }}
										shadowOpacity={0.05}
										shadowRadius={8}
										elevation={2}
									>
										<HStack justifyContent="space-between" alignItems="center">
											<Box flex={2}>
												<Typography.Paragraph
													sx={{
														fontFamily: "Roboto_700Bold",
														color: "$neutral700",
														fontSize: "$paragraphdesktop",
													}}
												>
													{item.stockcode}
												</Typography.Paragraph>
											</Box>
											<Box flex={4}>
												<Typography.Paragraph
													sx={{
														color: "$neutral600",
														lineHeight: 24,
														fontSize: "$paragraphdesktop",
													}}
												>
													{item.description}
												</Typography.Paragraph>
											</Box>
											<Box flex={1} alignItems="center">
												<Typography.Paragraph
													sx={{
														fontFamily: "Roboto_700Bold",
														color: "$neutral700",
														fontSize: "$paragraphdesktop",
													}}
												>
													{item.quantity}
												</Typography.Paragraph>
											</Box>
											<Box flex={1} alignItems="flex-end">
												<Typography.Paragraph
													sx={{
														fontFamily: "Roboto_700Bold",
														color: "$primarylight",
														fontSize: "$paragraphdesktop",
													}}
												>
													<FormattedCurrency amount={item.total} />
												</Typography.Paragraph>
											</Box>
										</HStack>
									</Box>
								))}
							</VStack>

							<Box marginTop={24} padding={24} bg="$basicwhite" borderRadius={12}>
								<HStack justifyContent="space-between" alignItems="center">
									<Typography.H5>Total Amount</Typography.H5>
									<FormattedCurrency amount={data?.total || 0} />
								</HStack>
							</Box>
						</Box>
					</Section>
				</Box>
			</Container>
		</ScrollContainer>
	);
}
